import { axiosPrivate } from "../../api/axios";
import { useEffect } from "react";
import handleError from "../../hooks/handleError";


// Save Accounts ("Save Changes")
const saveMoneyAccounts = (Money_Accounts) => {

    let isMounted = true;
    const controller = new AbortController();

    const MoneyAccountsToInsert = Money_Accounts.filter((row) => row.actions === "INSERT");
    const MoneyAccountsToUpdate = Money_Accounts.filter((row) => row.actions === "UPDATE");
    const MoneyAccountsToDelete = Money_Accounts.filter((row) => row.actions === "DELETE");

    const insertMoneyAccounts = async (MoneyAccountsToInsert) => {
        try {
            await axiosPrivate.post("/money-accounts",
                MoneyAccountsToInsert,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const updateMoneyAccounts = async (MoneyAccountsToUpdate) => {
        try {
            await axiosPrivate.post("/money-accounts",
                MoneyAccountsToUpdate,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const deleteMoneyAccounts = async (MoneyAccountsToDelete) => {
        try {
            await axiosPrivate.post("/money-accounts",
                MoneyAccountsToDelete,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    if (MoneyAccountsToDelete.length > 0) { deleteMoneyAccounts(MoneyAccountsToDelete) };
    if (MoneyAccountsToInsert.length > 0) { insertMoneyAccounts(MoneyAccountsToInsert) };
    if (MoneyAccountsToUpdate.length > 0) { updateMoneyAccounts(MoneyAccountsToUpdate) };

};
export default saveMoneyAccounts